// BOT-EDIT: 2025-01-27T10:50:00Z Create firebaseStorage utility for web version
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { storage } from '../firebase/config';

// 인보이스 PDF를 Firebase Storage에 업로드
export async function uploadInvoiceToStorage(
  pdfBlob: Blob,
  userId: string,
  invoiceId: string,
  cardId?: string
): Promise<string> {
  try {
    const fileName = `${invoiceId}.pdf`;
    // 앱과 동일한 경로 구조 사용: users/{userId}/cards/{cardId}/invoices/{fileName}
    const storagePath = cardId 
      ? `users/${userId}/cards/${cardId}/invoices/${fileName}`
      : `users/${userId}/invoices/${fileName}`;
    const fileRef = ref(storage, storagePath);
    
    // PDF 업로드
    const snapshot = await uploadBytes(fileRef, pdfBlob, {
      contentType: 'application/pdf',
      cacheControl: 'public, max-age=31536000'
    });
    
    // 다운로드 URL 반환
    const downloadURL = await getDownloadURL(snapshot.ref);
    return downloadURL;
  } catch (error) {
    console.error('Error uploading invoice to storage:', error);
    throw new Error('Failed to upload invoice PDF');
  }
}

// 파일을 Firebase Storage에 업로드 (일반용)
export async function uploadFileToStorage(
  file: File,
  path: string,
  userId: string
): Promise<string> {
  try {
    const fileName = `${Date.now()}_${file.name}`;
    const fileRef = ref(storage, `${path}/${userId}/${fileName}`);
    
    const snapshot = await uploadBytes(fileRef, file, {
      contentType: file.type,
      cacheControl: 'public, max-age=31536000'
    });
    
    const downloadURL = await getDownloadURL(snapshot.ref);
    return downloadURL;
  } catch (error) {
    console.error('Error uploading file to storage:', error);
    throw new Error('Failed to upload file');
  }
}

// 이미지를 Firebase Storage에 업로드
export async function uploadImageToStorage(
  imageFile: File,
  userId: string,
  folder: string = 'images'
): Promise<string> {
  try {
    const fileName = `${Date.now()}_${imageFile.name}`;
    const imageRef = ref(storage, `${folder}/${userId}/${fileName}`);
    
    const snapshot = await uploadBytes(imageRef, imageFile, {
      contentType: imageFile.type,
      cacheControl: 'public, max-age=31536000'
    });
    
    const downloadURL = await getDownloadURL(snapshot.ref);
    return downloadURL;
  } catch (error) {
    console.error('Error uploading image to storage:', error);
    throw new Error('Failed to upload image');
  }
}
